export default "__VITE_ASSET__DHFaqOaE__"